import React, {Fragment, useEffect, useState} from 'react'
import useOnEvent from 'react-app-events/lib/useOnEvent'
import useURLState from '@hooks/useURLState'
import {useTranslation} from 'next-i18next'

import CartMenu from './CartMenu'
import Content from './Content'

import styles from './styles.module.css'

export default function Cart(props) {
  const {preferences, layout, website, defaultScreen = 'resume'} = props
  const {menuId, tableName, deliveryType, cart} = preferences
  const [seeTableOrder, setSeeTableOrder] = useURLState('seeTableOrder')
  const isOpenQueryParam = seeTableOrder === 'true'
  const [open, setOpen] = useState(isOpenQueryParam)
  const {t} = useTranslation('website', {keyPrefix: 'order'})

  useEffect(() => {
    if (!open && isOpenQueryParam) setSeeTableOrder('false')
  }, [open, isOpenQueryParam, setSeeTableOrder])

  useEffect(() => {
    if (isOpenQueryParam) setOpen(true)
  }, [isOpenQueryParam, seeTableOrder])

  useOnEvent('setOpenCartMobile', value => {
    setOpen(value)
  })

  const renderCartContent = () => {
    if (!cart) {
      return (
        <div className={styles.loadingContainer}>
          <div className={styles.loading}></div>
        </div>
      )
    }

    if (!menuId || !deliveryType) {
      return <div className={styles.empty}>{t('cart.emptyCart')}</div>
    }

    return (
      <Content
        preferences={preferences}
        website={website}
        layout={layout}
        setOpenResume={setOpen}
        defaultScreen={defaultScreen}
      />
    )
  }

  const renderCart = () => {
    return (
      <div className={styles.container}>
        <div className={styles.title}>
          {tableName ? t('tableDetails', {table: tableName}) : t('titleMyOrder')}
        </div>
        {renderCartContent()}
      </div>
    )
  }

  if (layout === 'mobile') {
    return (
      <Fragment>
        <CartMenu
          preferences={preferences}
          cart={cart}
          open={open}
          onClick={() => setOpen(!open)}
        />
        {open ? (
          <div className={styles.cartSmall}>
            {renderCart()}
            <div className={styles.iosBottomBar} />
          </div>
        ) : null}
      </Fragment>
    )
  }

  return <div className={styles.cartBig}>{renderCart()}</div>
}
